import { render, staticRenderFns } from "./OSHConversationShow.vue?vue&type=template&id=12dd1811&"
import script from "./OSHConversationShow.vue?vue&type=script&lang=js&"
export * from "./OSHConversationShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports